import { getTzParts, tzBuild } from './data-explorer/data-explorer-time-range.utils';

/** Subtracts calendar days from a UTC instant in the given IANA timezone, accounting for DST. */
export function tzSubDays(date: Date, days: number, tz: string): Date {
  const p = getTzParts(date, tz);
  return tzBuild(p.year, p.month, p.day - days, p.hour, p.minute, p.second, 0, tz);
}

/** Formats a UTC instant as YYYY-MM-DD in the given IANA timezone. */
export function formatCalendarDate(date: Date, tz: string): string {
  const parts = getTzParts(date, tz);
  return `${parts.year}-${String(parts.month).padStart(2, '0')}-${String(parts.day).padStart(2, '0')}`;
}
